import React, { useEffect, useState } from 'react';
import { Box, Paper, Button, Typography, Grid, Divider } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { UserInfo } from '../../dto/UserInfo';
import { mostraMensagemErro } from '../../helpers/Notificacoes';
import { EmpresaServices } from '../../services/EmpresaService';
import { Empresa } from '../../dto/Empresa';
import { UsuarioServices } from '../../services/UsuarioService';
import { Usuario } from '../../dto/Usuario';
import { AuthService } from '../../services/AuthService';
import { BusinessRounded, Check, ClearRounded, DomainRounded, HeadsetMic, PersonRounded } from '@mui/icons-material';
import { ModoBarra } from '../../components/utils';
import CustomTableSelectEmpresasSup from '../../components/customTableSelectEmpresas/customTableSelectEmpresasSup';
import CustomTableSelectUsuariosSup from '../../components/customTableSelectUsuarios/customTableSelectUsuariosSup';


function HomeAdm() {
    const navigate = useNavigate();
    const empresaService = new EmpresaServices();
    const usuarioService = new UsuarioServices();
    const authService = new AuthService();
    //const userInfo: UserInfo = JSON.parse(localStorage.getItem("udbs")!);

    const [empresas, setEmpresas] = useState<Empresa[]>([]);
    const [empresaSelecionada, setEmpresaSelecionada] = useState<Empresa | null>(null);
    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const [usuarioSelecionado, setUsuarioSelecionado] = useState<Usuario | null>(null);
    const [erro, setErro] = useState("");

    useEffect(() => {
        if (empresas.length === 0) {
            buscaEmpresas();
        }
    }, [empresas]);

    async function buscaEmpresas() {
        const response = await empresaService.get(`/v1/empresas`);
        if (response.codigo !== 200) {
            if (response.codigo === 404) {
                setErro("Não há registros");
            } else {
                setErro(response.mensagem);
            }
        } else {
            setErro("");
            setEmpresas(response.status ?? []);
        }
    }

    async function buscaUsuarios(idEmpresa: string) {
        const response = await usuarioService.get(`/v1/usuarios?idEmpresa=${idEmpresa}`);
        if (response.codigo !== 200) {
            if (response.codigo === 404) {
                setErro("Não há registros");
            } else {
                setErro(response.mensagem);
            }
        } else {
            setErro("");
            setUsuarios(response.status ?? []);
        }
    }

    const handleSelecionarEmpresa = (empresa: Empresa) => {
        setEmpresaSelecionada(empresa);
        setUsuarios([]);
        buscaUsuarios(empresa.idEmpresa!);
        setUsuarioSelecionado(null);
    };

    const handleSelecionarUsuario = (usuario: Usuario) => {
        setUsuarioSelecionado(usuario);
    };

    const handleGeraAuthUsuario = async (userInfo: UserInfo) => {
        const response = await authService.solicitaAuthAdm(
            {
                userInfo
            },
            "/v1/authAdm"
        ).then((response: any) => {
            console.log("response:", response);
            return response;
        })
            .catch((error: any) => {
                return error;
            });

        if (response.codigo !== 200) {
            mostraMensagemErro(response.mensagem || "Erro ao gerar solicitação, tente novamente");
        }
    }

    async function handleClick() {
        const userInfo: UserInfo = {
            idEmpresa: empresaSelecionada!.idEmpresa!,
            idUsuario: usuarioSelecionado!.id,
            idAgente: usuarioSelecionado!.idAgente!,
            nomeEmpresa: empresaSelecionada!.descricao,
            nome: usuarioSelecionado!.nome,
            email: usuarioSelecionado!.email,
            isAdm: usuarioSelecionado!.isAdm?.toString() === 'S' ? true : false,
            agentes: usuarioSelecionado!.agentes ?? [],
        }

        try {
            await handleGeraAuthUsuario(userInfo);

            await localStorage.setItem('stbs', "true");
            await localStorage.setItem('udbs', JSON.stringify(userInfo));
            navigate("/mvp");

        } catch (error: any) {
            mostraMensagemErro(error.mesage || "Erro ao gerar solicitação, tente novamente");
        }
    }

    return (
        <div className="paginaCadastro">
            <Paper elevation={0} className='usuarios-paper-header'>
                <Box className='usuarios-header-top'>
                    <Box className='usuarios-title-wrap' sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                        <Box className='usuarios-title-icon'>
                            <HeadsetMic />
                        </Box>

                        <Box>
                            <Box >
                                <Typography variant='h6' className='usuarios-title'>
                                    Portal de Suporte Pedidos Odin
                                </Typography>
                            </Box>
                            <Typography className='usuarios-subtitle'>
                                Selecione a empresa e o usuário para acessar o sistema.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Paper>

            <Grid container spacing={1}>
                <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <BusinessRounded sx={{ color: '#0965c1', fontSize: 24, marginBottom: 1 }} />
                            <Typography marginBottom={0} align='center' component="h2" fontSize='16px' color='#334155'>
                                1. Selecionar Empresa
                            </Typography>
                        </Box>
                        <Divider sx={{ width: '100%', marginBottom: 2, marginTop: -0.4 }} />

                        <CustomTableSelectEmpresasSup
                            data={empresas}
                            handleSetEmpresa={handleSelecionarEmpresa}
                            empresaSelecionada={empresaSelecionada}
                        />
                    </Paper>
                </Grid>

                {/* Painel 2 - Ocupa a outra metade */}
                <Grid item xs={12} md={6}>
                    <Paper elevation={2} sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <PersonRounded sx={{ color: '#0965c1', fontSize: 24, marginBottom: 1 }} />
                            <Typography marginBottom={0} align='center' component="h2" fontSize='16px' color='#334155'>
                                2. Selecionar Usuário
                            </Typography>
                        </Box>
                        <Divider sx={{ width: '100%', marginBottom: 2, marginTop: -0.4 }} />

                        <CustomTableSelectUsuariosSup
                            data={usuarios}
                            buscouUsuarios={true}
                            handleSetUsuario={handleSelecionarUsuario}
                            usuarioSelecionado={usuarioSelecionado}
                        />

                    </Paper>
                </Grid>
            </Grid>
            <Paper
                elevation={0}
                sx={{
                    borderRadius: '4px',
                    border: '1px solid #d9e5ee',
                    width: '100%',
                    padding: '14px 16px',
                    display: 'flex',
                    paddingTop: '20px !important',
                    paddingBottom: '6px !important',
                    justifyContent: 'space-between',
                    backgroundColor: '#e9f2fd !important',
                    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
                    marginTop: 1
                }}
            >
                {/*
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '33%', overflow: 'hidden' }}>
                     {empresaSelecionada ? <Check sx={{ color: '#0965c1', flexShrink: 0 }} /> : <ClearRounded sx={{ color: '#E53E3E', flexShrink: 0 }} />}
                    <Box sx={{ overflow: 'hidden' }}>
                        <Typography variant="caption" sx={{ color: '#64748b', display: 'block' }}>Empresa</Typography>
                        <Typography
                            sx={{ fontWeight: 500, color: '#334155', fontSize: '13px' }}
                            noWrap 
                        >
                            {empresaSelecionada ? empresaSelecionada.descricao : "Nenhuma selecionada"}
                        </Typography>
                    </Box>
                </Box>

                <Divider orientation="vertical" flexItem sx={{ borderColor: '#CBD5E1' }} />

            
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '33%', overflow: 'hidden' }}>
                    {usuarioSelecionado ? <Check sx={{ color: '#0965c1', flexShrink: 0 }} /> : <ClearRounded sx={{ color: '#E53E3E', flexShrink: 0 }} />}
                    <Box sx={{ overflow: 'hidden' }}>
                        <Typography variant="caption" sx={{ color: '#64748b', display: 'block' }}>Usuário</Typography>
                        <Typography
                            sx={{ fontWeight: 500, color: '#334155', fontSize: '13px' }}
                            noWrap
                        >
                            {usuarioSelecionado ? usuarioSelecionado.nome : "Nenhum selecionado"}
                        </Typography>
                    </Box>
                </Box> */}

                <Typography
                    sx={{
                        fontWeight: 500,
                        color: '#334155',
                        fontSize: '16px',
                        marginTop: -1
                    }}
                >
                    {empresaSelecionada && usuarioSelecionado ? (
                        // Caso ambos estejam selecionados
                        <>
                            Fazer login com a empresa <strong>{empresaSelecionada.descricao}</strong>
                            {" e o usuário "}
                            <strong>{usuarioSelecionado.nome}</strong>
                        </>
                    ) : (
                        // Caso algum não esteja selecionado (mensagem de instrução)
                        <span style={{ color: '#64748b', fontStyle: 'italic' }}>
                            Selecione uma empresa e um usuário para realizar o acesso.
                        </span>
                    )}
                </Typography>

                {/*  <Divider orientation="vertical" flexItem sx={{ borderColor: '#CBD5E1' }} /> */}

                {/* Contêiner do Botão - Largura Fixa (ex: 120px) */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginRight: 3, marginTop: -1.5 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleClick}
                        disabled={!empresaSelecionada || !usuarioSelecionado}
                        sx={{
                            padding: '6px 16px',
                            fontSize: '14px',
                            textTransform: 'none',
                            width: '150px'
                        }}
                    >
                        Acessar Sistema
                    </Button>
                </Box>
            </Paper>

        </div >
    );
}

export default HomeAdm;
